// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Itme","inner":"Footer_inner__2DcTo"};